/*
 * use-ambient-light
 */
import { useEffect, useState } from "react"

export function useAmbientLight(): number {
	const [light, setLight] = useState(
		typeof window !== "undefined" && "ondevicelight" in window ? 0 : -1,
	)

	useEffect(() => {
		if (typeof window === "undefined" || !("ondevicelight" in window)) {
			return
		}

		function onLightChange({ value }: any) {
			setLight(value)
		}

		window.addEventListener("devicelight", onLightChange)

		return () => {
			window.removeEventListener("devicelight", onLightChange)
		}
	}, [])

	return light
}
